export default __webpack_public_path__ + "static/media/Logo.1b47b926.svg";